import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useFetchSpecifications from '../../../hooks/specifications/useFetchSpecifications';
import { createVehicleAction } from '../../../redux/actions/vehicleActions';
import { convertToVehicleRequest } from '../../../utils/requestMapper';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import VehicleForm from '../forms/VehicleForm';

const CreateVehicleModal = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);
  const { specifications, loading } = useFetchSpecifications();

  const onSubmit = async (data) => {
    setCreating(true);
    const vehicleRequest = convertToVehicleRequest(data);
    await dispatch(createVehicleAction(vehicleRequest, navigate));
    setCreating(false);
  };

  return (
    <Modal
      title={'Додати автомобіль'}
      loading={creating}
      onClose={onModalClose}
      body={
        !loading && (
          <VehicleForm
            readOnly={false}
            onSubmit={onSubmit}
            loading={creating}
            isUpdating={false}
            specifications={specifications}
          />
        )
      }
      actionButton={
        <Button type={'submit'} disabled={creating} variant={'primary'} formId={'vehicle-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreateVehicleModal;
